

import React, { useState } from "react";
import {
  Typography,
  Box,
  Grid,
  Paper,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import dayjs from "dayjs";





const ScannedDataDetails = ({ scannedData }) => {


  const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));
  const locationLabels = {
    "Vehicles": "1",
    "Bustand": "2",
    "Railway Station": "3",
    "Invoice": "4",
    "Restaurant": "5",
    "Social Media": "6",
    "Mallige Hotel": "7",
    "Website":"8",
    default: "Others",
  };

  if (!scannedData || scannedData.length === 0) {
    return (
      <Box sx={{ padding: 4, display: "flex", justifyContent: "center" }}>
        <Typography variant="h6" color="textSecondary">
          No promotion data available
        </Typography>
      </Box>
    );
  }

  // Filter data by selected month
  const filteredData = scannedData.filter(
    (item) => dayjs(item.timestamp).format("YYYY-MM") === selectedMonth
  );

  // Group data by location
  const groupedByLocation = filteredData.reduce((acc, item) => {
    const { location, deviceType } = item;
    if (!acc[location]) {
      acc[location] = { total: 0, android: 0, iphone: 0 };
    }
  
    acc[location].total += 1; // Increment total count
    if (deviceType === "android") acc[location].android += 1;
    if (deviceType === "iphone") acc[location].iphone += 1;
  
    return acc;
  }, {});

  // Prepare data for the chart and table
  const chartData = Object.entries(groupedByLocation).map(
    ([location, count]) => ({
      location,
      count,
    })
  );
  const topPerforming = chartData.sort((a, b) => b.count - a.count).slice(0, 5);

  // Handle month change
  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  

  return (
    <Box sx={{ padding: 2 }}>
     

      {/* Month Selector */}
      <Box sx={{ marginBottom: 4 }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="month-select-label">Month</InputLabel>
          <Select
            labelId="month-select-label"
            value={selectedMonth}
            onChange={handleMonthChange}
            label="Select Month"
          >
            {Array.from({ length: 12 }).map((_, i) => {
              const month = dayjs().subtract(i, "month").format("YYYY-MM");
              return (
                <MenuItem key={month} value={month}>
                  {dayjs(month).format("MMMM YYYY")}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>

      
      {/* Top Performing Table */}
      <Paper elevation={3} sx={{ padding: 4 }}>
  <Typography variant="h6" sx={{ marginBottom: 2 }}>
    Top Performing QR Codes
  </Typography>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell>Location</TableCell>
        <TableCell>Total Scans</TableCell>
        <TableCell>Android</TableCell>
        <TableCell>iPhone</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
    {Object.entries(groupedByLocation).map(([location, deviceCounts]) => {
        const locationLabel = locationLabels[location] || locationLabels.default;
        return (
          <TableRow key={location}>
            <TableCell>
              {location} ({locationLabel}) {/* Display label and number */}
            </TableCell>
            <TableCell>{deviceCounts.total}</TableCell>
            <TableCell>{deviceCounts.android || 0}</TableCell>
            <TableCell>{deviceCounts.iPhone || 0}</TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
</Paper>
    </Box>
  );
};

export default ScannedDataDetails;
